import { ApprovalFlowsPage } from '@hq/sys-admin';
import { hq } from '../session';

/**
 * 审批流（平台侧跨租户）：流程/节点/条件路由/独立授权。
 * 页面实现收敛在 `@hq/sys-admin`，本端开启「来源」列（平台模板 / 租户 #N）。
 */
export default function ApprovalFlows() {
  return <ApprovalFlowsPage platform hq={hq} />;
}
